// src/v3/actions/edit.tsx
import SvgIcon from "@mui/material/SvgIcon";
import { jsx } from "react/jsx-runtime";
var EditIcon = (props) => /* @__PURE__ */ jsx(SvgIcon, { "data-testid": "EditIcon", viewBox: "0 0 24 24", ...props, children: /* @__PURE__ */ jsx(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "currentColor",
    d: "M20.9403 7.25915L16.7516 3.06947C16.6123 2.93014 16.4469 2.81962 16.2649 2.74422C16.0829 2.66881 15.8878 2.63 15.6908 2.63C15.4938 2.63 15.2987 2.66881 15.1167 2.74422C14.9347 2.81962 14.7693 2.93014 14.63 3.06947L3.0697 14.6307C2.92981 14.7695 2.81889 14.9347 2.74341 15.1167C2.66793 15.2988 2.62938 15.494 2.63001 15.691V19.8807C2.63001 20.2785 2.78805 20.6601 3.06935 20.9414C3.35066 21.2227 3.73219 21.3807 4.13001 21.3807H8.3197C8.51676 21.3813 8.71197 21.3428 8.894 21.2673C9.07602 21.1918 9.24123 21.0809 9.38001 20.941L20.9403 9.38072C21.0796 9.24142 21.1902 9.07605 21.2656 8.89404C21.341 8.71203 21.3798 8.51695 21.3798 8.31993C21.3798 8.12292 21.341 7.92784 21.2656 7.74583C21.1902 7.56382 21.0796 7.39845 20.9403 7.25915ZM8.3197 19.8807H4.13001V15.691L12.38 7.44103L16.5697 11.6307L8.3197 19.8807ZM17.63 10.5695L13.4403 6.38072L15.6903 4.13072L19.88 8.31947L17.63 10.5695Z"
  }
) });

export {
  EditIcon
};
